import * as isNumber from 'lodash/isNumber'
import { State } from 'interfaces/state'
import { Guards } from 'interfaces/guards'
import { TimeframeTyped } from 'interfaces/global'
import { connectShadedLoadable, createParallelGuard } from 'helpers/loadableHelpers'
import { peergroupsGuard } from 'guards/globalGuards'
import { selectedRelationSelector } from 'selectors/peergroupSelectors'
import { memberAccountsBreakdownGuard, peergroupAccountsBreakdownGuard } from 'guards/accountGuards'
import AccountsBreakdown, { AccountsBreakdownStateProps, AccountsBreakdownOwnProps } from 'components/features/pfm/AccountsBreakdown/AccountsBreakdown'
import { selectedPeergroupIdSelector, yourPeergroupIdSelector } from 'selectors/peergroupSelectors'
import { createTimeperiod } from 'helpers/dateTimeHelpers'
import { createForgottenGuardError } from 'helpers/errorHelpers'
import { withComparisonSelector } from 'components/features/pageFilters/selectors'

type AccountsBreakdownModuleContainerOwnProps =
  & AccountsBreakdownOwnProps
  & TimeframeTyped

const mapStateToProps = (state: State, { type, timeframe }: AccountsBreakdownModuleContainerOwnProps): AccountsBreakdownStateProps => {
  const { meta } = state.data
  const withComparison = withComparisonSelector(state)
  const yourPeergroupId = yourPeergroupIdSelector(state)
  const selectedPeergroupId = selectedPeergroupIdSelector(state)
  const selectedRelation = selectedRelationSelector(state)

  if (!isNumber(yourPeergroupId) || !isNumber(selectedPeergroupId)) {
    throw createForgottenGuardError('AccountsBreakdownModuleContainer', 'peergroupsGuard')
  }
  const date = createTimeperiod(timeframe).end_date

  const memberBreakdown = state.data[type].breakdown[date]
  const peersBreakdown = state.data.peergroups[type].breakdown[date]

  const categories = meta[type === 'debts' ? 'debt_categories' : 'asset_categories']

  return {
    categories,
    memberValue: memberBreakdown,
    peerValue: peersBreakdown.byKey[yourPeergroupId].breakdown,
    otherValue: peersBreakdown.byKey[selectedPeergroupId].breakdown,
    selectedCategoryId: state.app[type].categories.selectedId,
    othersName: selectedRelation ? selectedRelation.name : '',
    withComparison,
  }
}

const accountsBreakdownGuards: Guards<AccountsBreakdownModuleContainerOwnProps> = [
  peergroupsGuard,
  createParallelGuard(memberAccountsBreakdownGuard, peergroupAccountsBreakdownGuard),
]

const AccountsBreakdownModuleContainer = connectShadedLoadable<
  AccountsBreakdownStateProps,
  {},
  AccountsBreakdownModuleContainerOwnProps
>(mapStateToProps, undefined, accountsBreakdownGuards)(AccountsBreakdown)
export default AccountsBreakdownModuleContainer
